module.exports = __webpack_public_path__ + "img/schnittkante_tiefschwarz_ral9005.526ef442.jpg";